<template>
  <button v-show="cashoutPrice > 0" class="Button-styles-button Button-styles-primary Button-styles-general" @click="cashoutItNow(bet.id)">
    <div class=""><span class="CashoutButton-styles-button-text">{{ t.cashout || 'Cashout for' }} {{ cashoutPrice | toMoney(bet.currency) }}</span>
    </div>
    <div v-show="loader" class="Preloader-styles-container"><div class="Spinner-styles-spinner-image"></div><span class="Preloader-styles-label"></span></div>
  </button>
</template>

<script>
import betSlip from "../../../mixins/betSlip";
export default {
  name: 'cashoutButton',
  props: ['bet', 'bi'],
  mixins: [betSlip],
  data () {
    return {
      t: this.$root.t,
      cashoutPrice: 0,
      refrestInt: null,
      loader: false
    }
  },
  beforeDestroy() {
    clearInterval(this.refrestInt);
  },
  mounted(){
    this.getCashoutPrice(this.bet.id);
    this.refrestInt = setInterval(this.refresh, 5000);
  },
  methods: {
    refresh() {
      this.getCashoutPrice(this.bet.id)
    },
    getCashoutPrice (id) {
      //if(this.bet.)
      if(this.bet.result.key === 'waiting'){
        this.cashout(id).then((response) => {
          this.cashoutPrice = 0;
          if(response.status === 200){
            this.cashoutPrice = response.body.cashout;
          }else {
            this.cashoutPrice = 0;
          }
        }, response => {

          this.cashoutPrice = 0;

        })
      }
    },
    cashoutItNow (id) {
      swal({
        title: this.$root.t.alert.are_you_sure,
        text: this.$root.t.alert.cannot_revert,
        icon: 'warning',
        buttons: [
          this.$root.t.alert.button.not_sure,
          this.$root.t.alert.button.yes,
        ],
        dangerMode: true,
      }).then((isConfirm) => {
        if (isConfirm) {
          this.loader = true
          this.cashoutNow(id).then((response) => {
            this.cashoutPrice = 0;
            this.showRow = false;
            this.loader = false
            swal(
                'Cashout!',
                this.$root.t.alert.success,
                'success'
            )
            this.$emit('cashouted', this.bi)
          }, response => {
            this.cashoutPrice = 0;
            this.loader = false
            swal(
                'Cashout!',
                this.$root.t.alert.error,
            )
          })

        }
      });

      /*
      this.cashoutNow(id).then((response) => {
        this.cashoutPrice = response.data.cashout;
      }) */
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/widget/cashoutButton.vue